var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 293,
    viewBox: "0 0 244 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161.15,
    cy: 3.90625,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.15,
    cy: 51.4297,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.15,
    cy: 98.9531,
    r: 3,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.15,
    cy: 242.885,
    r: 3,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.15,
    cy: 289.885,
    r: 3,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.674,
    cy: 3.90625,
    r: 3,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.674,
    cy: 51.4297,
    r: 3,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.674,
    cy: 98.9531,
    r: 3,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.674,
    cy: 242.885,
    r: 3,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.674,
    cy: 289.885,
    r: 3,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.196,
    cy: 98.9531,
    r: 3,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.196,
    cy: 289.885,
    r: 3,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.05859,
    cy: 3.90625,
    r: 3,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.05859,
    cy: 98.9531,
    r: 3,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.05859,
    cy: 51.4297,
    r: 3,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.05859,
    cy: 146.637,
    r: 3,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.05859,
    cy: 194.977,
    r: 3,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.05859,
    cy: 242.885,
    r: 3,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.05859,
    cy: 289.885,
    r: 3,
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.2432,
    cy: 98.9531,
    r: 3,
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.582,
    cy: 3.90625,
    r: 3,
    fill: "white"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.582,
    cy: 51.4297,
    r: 3,
    fill: "white"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.2432,
    cy: 146.27,
    r: 3,
    fill: "white"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.582,
    cy: 194.977,
    r: 3,
    fill: "white"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.582,
    cy: 242.885,
    r: 3,
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.582,
    cy: 289.885,
    r: 3,
    fill: "white"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.1045,
    cy: 3.90625,
    r: 3,
    fill: "white"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.1045,
    cy: 51.4297,
    r: 3,
    fill: "white"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.1045,
    cy: 98.9531,
    r: 3,
    fill: "white"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.1045,
    cy: 194.977,
    r: 3,
    fill: "white"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.1045,
    cy: 242.885,
    r: 3,
    fill: "white"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.1045,
    cy: 289.885,
    r: 3,
    fill: "white"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.627,
    cy: 3.90625,
    r: 3,
    fill: "white"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.627,
    cy: 51.4297,
    r: 3,
    fill: "white"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.627,
    cy: 98.9531,
    r: 3,
    fill: "white"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.627,
    cy: 242.885,
    r: 3,
    fill: "white"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.627,
    cy: 289.885,
    r: 3,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPattern);
export default __webpack_public_path__ + "static/media/dotPattern.723f977499a599ff27bc7757f2754f84.svg";
export { ForwardRef as ReactComponent };